@if (bundle) {
  <div class="padding">
    <div class="flex-container-right-align">
      <button (click)="deleteBundleConfirmation()" mat-flat-button color="warn" class="margin-sides-5">
        <mat-icon>delete</mat-icon>
        {{ 'common.buttons.delete' | transloco }}
      </button>
      <button mat-flat-button [matMenuTriggerFor]="menu" color="primary" [attr.aria-label]="'bundles.addBatch' | transloco"
        class="margin-sides-5">
        {{ 'bundles.addBatch' | transloco }}
        <mat-icon>double_arrow</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        @for (type of _batchTypes; track type) {
          <div>
            <button (click)="addBatch(type.value)" mat-menu-item color="accent" class="margin-sides-5">
              <span>{{ type.label | transloco }}</span>
            </button>
          </div>
        }
      </mat-menu>
      <button (click)="addBundleOrders()" mat-flat-button color="primary" class="margin-sides-5">
        <mat-icon>add</mat-icon>
        {{ 'bundles.addOrders' | transloco }}
      </button>
    </div>
    <div class="flex-container-left-align">
      <h1 class="left-box">{{this.bundle.name}}</h1>
    </div>
    <mat-card>
      <mat-card-content>
        <div class="flex-container">
          {{this.bundle.description}}
        </div>
        <div class="table-container">
          <mat-tab-group animationDuration="0ms" [selectedIndex]="selectedIndex">
            <mat-tab [label]="'common.labels.batches' | transloco">
              <div class="flex-container">
                <p class="intro-text padding-bottom-25 padding-top-25">{{ 'bundles.aMethodOfSubmittingMultipleOrders' | transloco }}</p>
              </div>
              <app-batches-list></app-batches-list>
            </mat-tab>
            <mat-tab [label]="'bundles.bundleOrders' | transloco">
              <app-bundle-orders-list></app-bundle-orders-list>
            </mat-tab>
          </mat-tab-group>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
}